import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import Buckets from './Buckets';
import Notifications from './Notifications';
import Workflows from './Workflows';
import styles from './workflowOrchestrator.module.scss';

const TABS = [
  {key: 'BUCKETS', label: 'Buckets'},
  {key: 'WORKFLOWS', label: 'Workflows'},
  {key: 'NOTIFICATIONS', label: 'Notifications'},
];

const WorkflowOrchestrator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParamValue = new URLSearchParams(location.search).get('route');

  const [activeTab, setActiveTab] = useState('BUCKETS');

  useEffect(() => {
    if (searchParamValue && TABS.some(t => t.key === searchParamValue)) {
      setActiveTab(searchParamValue);
    } else {
      setActiveTab('BUCKETS');
    }
  }, [searchParamValue]);

  return (
    <div>
      <div className={styles.header}>
        <div>
          <h1>Workflow Orchestrator</h1>
          <p>
            Group notifications into buckets and assign workflows. Master
            on/off, approval flow and fallback approvers live in Platform
            Settings → Notification Workflow Governance.
          </p>
        </div>
      </div>

      <div className={styles['details-toggler']}>
        {TABS.map(tab => (
          <span
            key={tab.key}
            className={activeTab === tab.key ? styles['active-toggle'] : ''}
            onClick={() => navigate(`?route=${tab.key}`)}>
            {tab.label}
          </span>
        ))}
      </div>

      {activeTab === 'BUCKETS' && <Buckets />}
      {activeTab === 'WORKFLOWS' && <Workflows />}
      {activeTab === 'NOTIFICATIONS' && <Notifications />}
    </div>
  );
};

export {WorkflowOrchestrator};
